export const COLOR_PALETTE = {
  common: {
    darkBlue: '#055AA2',
    brandColor1: '#0072CE',
    white: '#FFFFFF',
    success: '#368639',
    warning: '#E06A05',
    error: '#BF2F2F',
    orange: '#FF8039',
    gold: '#E8B10D',
    sky80: '#CFDFF1',
    mediumGrey: '#E0E0E0',
    lightGrey: '#EFEFEF',
    brandColor3: '#C3D7EE',
    tangaroa: '#0F1929',
    dimGray: '#666666',
    paleBlue: '#cbd2d6',
    alabaster: '#F9F9F9',
    cinnabar: '#E1433A',
    eucalyptus: '#32985B',
    smokyGrey: '#CCCCCC',
    navy10: '#F3FAFF',
    black5: '#999999',
    black7: '#DDDDDD',
    thermalGreen: '#C7F8DA',
    thermalYellow: '#FFF5DD',
  },
  dark: {
    lightBlue: '#66AAE2',
  },
  light: {
    navyBlue: '#3D515A',
    magnolia: '#F6F5FA',
    pattensBlue: '#E6EFF6',
    darkGray: '#B3B3B3',
    fuscousGrey: '#373637',
    oxfordBlue: '#263238',
    bodyBgColor: '#F0F3F5',
  },
};

export type NewColors = {
  grey: {
    100: React.CSSProperties['color'];
    200: React.CSSProperties['color'];
    300: React.CSSProperties['color'];
    400: React.CSSProperties['color'];
    500: React.CSSProperties['color'];
    600: React.CSSProperties['color'];
    700: React.CSSProperties['color'];
    800: React.CSSProperties['color'];
    900: React.CSSProperties['color'];
    1000: React.CSSProperties['color'];
  };
  brand: {
    50: React.CSSProperties['color'];
    100: React.CSSProperties['color'];
    200: React.CSSProperties['color'];
    300: React.CSSProperties['color'];
    400: React.CSSProperties['color'];
    500: React.CSSProperties['color'];
    600: React.CSSProperties['color'];
    700: React.CSSProperties['color'];
    800: React.CSSProperties['color'];
    900: React.CSSProperties['color'];
    1000: React.CSSProperties['color'];
  };
  danger: {
    100: React.CSSProperties['color'];
    200: React.CSSProperties['color'];
    300: React.CSSProperties['color'];
    400: React.CSSProperties['color'];
    500: React.CSSProperties['color'];
    600: React.CSSProperties['color'];
    700: React.CSSProperties['color'];
    800: React.CSSProperties['color'];
    900: React.CSSProperties['color'];
    1000: React.CSSProperties['color'];
  };
  success: {
    100: React.CSSProperties['color'];
    200: React.CSSProperties['color'];
    300: React.CSSProperties['color'];
    400: React.CSSProperties['color'];
    500: React.CSSProperties['color'];
    600: React.CSSProperties['color'];
    700: React.CSSProperties['color'];
    800: React.CSSProperties['color'];
    900: React.CSSProperties['color'];
    1000: React.CSSProperties['color'];
  };
  purple: {
    100: React.CSSProperties['color'];
    200: React.CSSProperties['color'];
    400: React.CSSProperties['color'];
    600: React.CSSProperties['color'];
    700: React.CSSProperties['color'];
    800: React.CSSProperties['color'];
  };
  teal: {
    100: React.CSSProperties['color'];
    200: React.CSSProperties['color'];
    400: React.CSSProperties['color'];
    600: React.CSSProperties['color'];
    700: React.CSSProperties['color'];
    800: React.CSSProperties['color'];
  };
  orange: {
    100: React.CSSProperties['color'];
    200: React.CSSProperties['color'];
    400: React.CSSProperties['color'];
    600: React.CSSProperties['color'];
    700: React.CSSProperties['color'];
    800: React.CSSProperties['color'];
  };
  warning: {
    100: React.CSSProperties['color'];
    200: React.CSSProperties['color'];
    300: React.CSSProperties['color'];
    400: React.CSSProperties['color'];
    500: React.CSSProperties['color'];
    600: React.CSSProperties['color'];
    700: React.CSSProperties['color'];
    800: React.CSSProperties['color'];
    900: React.CSSProperties['color'];
    1000: React.CSSProperties['color'];
  };
  background: {
    page: React.CSSProperties['color'];
    input: React.CSSProperties['color'];
    scrim: React.CSSProperties['color'];
  };
  text: {
    primary: React.CSSProperties['color'];
    secondary: React.CSSProperties['color'];
    tertiary: React.CSSProperties['color'];
    subtle: React.CSSProperties['color'];
  };
  common: {
    white: React.CSSProperties['color'];
    dropShadow: React.CSSProperties['color'];
    whiteSecondary: React.CSSProperties['color'];
  };
  line: {
    border: React.CSSProperties['color'];
    hairline: React.CSSProperties['color'];
  };
};

export type GraphColors = {
  graphLine1: React.CSSProperties['color'];
  graphLine2: React.CSSProperties['color'];
  gridLines: React.CSSProperties['color'];
  graphBar1: React.CSSProperties['color'];
  graphBar1Hover: React.CSSProperties['color'];
  graphBar2: React.CSSProperties['color'];
  graphBar2Hover: React.CSSProperties['color'];
  graphBar3: React.CSSProperties['color'];
  graphBar3Hover: React.CSSProperties['color'];
  graphBar4: React.CSSProperties['color'];
  graphBar4Hover: React.CSSProperties['color'];
};

export type DESIGN_SYSTEM_TOKENS = {
  textPrimary: React.CSSProperties['color'];
  textSecondary: React.CSSProperties['color'];
  textTertiary: React.CSSProperties['color'];
  pageBackground: React.CSSProperties['color'];
  brandPrimary: React.CSSProperties['color'];
  brandSecondary: React.CSSProperties['color'];
  brandTertiary: React.CSSProperties['color'];
  actionDefault: React.CSSProperties['color'];
  actionHover: React.CSSProperties['color'];
  actionFocus: React.CSSProperties['color'];
  actionSelected: React.CSSProperties['color'];
  actionActive: React.CSSProperties['color'];
  successPrimary: React.CSSProperties['color'];
  successSecondary: React.CSSProperties['color'];
  successTertiary: React.CSSProperties['color'];
  errorPrimary: React.CSSProperties['color'];
  errorSecondary: React.CSSProperties['color'];
  errorTertiary: React.CSSProperties['color'];
  warningPrimary: React.CSSProperties['color'];
  warningSecondary: React.CSSProperties['color'];
  warningTertiary: React.CSSProperties['color'];
  dangerPrimary: React.CSSProperties['color'];
  dangerSecondary: React.CSSProperties['color'];
  dangerTertiary: React.CSSProperties['color'];
  infoGrey: React.CSSProperties['color'];
  infoGreySecondary: React.CSSProperties['color'];
  infoGreyLight: React.CSSProperties['color'];
  border: React.CSSProperties['color'];
  lineDefault: React.CSSProperties['color'];
  inputBackground: React.CSSProperties['color'];
  inputBorder: React.CSSProperties['color'];
  navHoverBackground: React.CSSProperties['color'];
  navSelectedBackground: React.CSSProperties['color'];
};

/**
 * The single source of truth for design-system colors. `palette.*` and
 * `theme.new.color` both derive from this ramp, so a token cannot drift
 * between the two.
 */
export const DESIGN_SYSTEM_COLORS = {
  grey: {
    100: '#F0F1F5',
    200: '#EDEFF2',
    300: '#D6DBE1',
    400: '#B0B9C4',
    500: '#808C9A',
    600: '#525E6D',
    700: '#404C59',
    800: '#33404C',
    900: '#1B232A',
    1000: '#0C1114',
  },
  brand: {
    50: '#F8F9FE',
    100: '#F0F6FF',
    200: '#D6ECFF',
    300: '#A9D6FF',
    400: '#73B7FF',
    500: '#3894E9',
    600: '#0072CE',
    700: '#0666AC',
    800: '#0B598E',
    900: '#0A3852',
    1000: '#00161F',
  },
  danger: {
    100: '#FFF3F2',
    200: '#FFD1CC',
    300: '#FFAFA9',
    400: '#FF7872',
    500: '#E83C37',
    600: '#CC0300',
    700: '#A90606',
    800: '#870A0C',
    900: '#4E0A0D',
    1000: '#1F0001',
  },
  success: {
    100: '#F0FFF7',
    200: '#CFFCE3',
    300: '#95ECBB',
    400: '#5ED18F',
    500: '#29AB5F',
    600: '#008035',
    700: '#046B3C',
    800: '#085E2A',
    900: '#07381A',
    1000: '#001F0B',
  },
  purple: {
    100: '#F5F2FF',
    200: '#EBE5FF',
    400: '#9D86F9',
    600: '#7457E9',
    700: '#593BD1',
    800: '#4527BD',
  },
  teal: {
    100: '#EBFDFF',
    200: '#DBFBFF',
    400: '#28B7CA',
    600: '#1194A6',
    700: '#077685',
    800: '#025B67',
  },
  orange: {
    100: '#FFF7F0',
    200: '#FFECDE',
    400: '#E38A45',
    600: '#BF641F',
    700: '#994C11',
    800: '#7A3907',
  },
  warning: {
    100: '#FFFDF0',
    200: '#FFFFC2',
    300: '#FFFBAC',
    400: '#FFEC7A',
    500: '#FFD444',
    600: '#F2B50D',
    700: '#BF8E0F',
    800: '#5F3D07',
    900: '#4A3303',
    1000: '#1F1400',
  },
  background: {
    page: '#F0F1F5',
    input: '#0c111405',
    scrim: '#0C1114bf',
  },
  text: {
    primary: '#0C1114',
    secondary: '#525E6D',
    tertiary: '#B0B9C4',
    subtle: '#637183',
  },
  common: {
    white: '#FFFFFF',
    dropShadow: '#1d2a340f',
    whiteSecondary: '#FFFFFF',
  },
  line: {
    border: '#0c111433',
    hairline: '#0c11141a',
  },
} satisfies NewColors;

export const designSystemColors = (): DESIGN_SYSTEM_TOKENS &
  NewColors &
  GraphColors => {
  const colorScheme = DESIGN_SYSTEM_COLORS;

  return {
    textPrimary: colorScheme.text.primary,
    textSecondary: colorScheme.text.secondary,
    textTertiary: colorScheme.text.tertiary,
    pageBackground: colorScheme.background.page,
    brandPrimary: colorScheme.brand[600],
    brandSecondary: colorScheme.brand[200],
    brandTertiary: colorScheme.brand[100],
    actionDefault: colorScheme.brand[600],
    actionHover: colorScheme.brand[800],
    actionFocus: colorScheme.brand[500],
    actionSelected: colorScheme.brand[700],
    actionActive: colorScheme.brand[600],
    successPrimary: colorScheme.success[600],
    successSecondary: colorScheme.success[800],
    successTertiary: colorScheme.success[200],
    errorPrimary: colorScheme.danger[600],
    errorSecondary: colorScheme.danger[700],
    errorTertiary: colorScheme.danger[200],
    warningPrimary: colorScheme.warning[600],
    warningSecondary: colorScheme.warning[700],
    warningTertiary: colorScheme.warning[200],
    dangerPrimary: colorScheme.danger[600],
    dangerSecondary: colorScheme.danger[700],
    dangerTertiary: colorScheme.danger[200],
    infoGrey: colorScheme.grey[600],
    infoGreySecondary: colorScheme.grey[400],
    infoGreyLight: colorScheme.grey[200],
    border: colorScheme.line.border,
    lineDefault: colorScheme.line.hairline,
    inputBackground: colorScheme.background.input,
    inputBorder: colorScheme.line.border,
    navHoverBackground: colorScheme.brand[100],
    navSelectedBackground: colorScheme.brand[100],
    graphLine1: colorScheme.purple[600],
    graphLine2: colorScheme.brand[400],
    gridLines: colorScheme.grey[300],
    graphBar1: colorScheme.purple[400],
    graphBar1Hover: colorScheme.purple[700],
    graphBar2: colorScheme.teal[400],
    graphBar2Hover: colorScheme.teal[700],
    graphBar3: colorScheme.danger[400],
    graphBar3Hover: colorScheme.danger[600],
    graphBar4: colorScheme.brand[400],
    graphBar4Hover: colorScheme.brand[700],
    ...colorScheme,
  };
};
